import { filter } from "rxjs/operators";
import {
	ElementRef,
	Component,
	OnInit,
	OnDestroy,
	NgZone,
} from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { AuthService, LocalizeService, InsaService } from "./insa-services";
import { Title } from "@angular/platform-browser";

import { appStateProvider } from "./insa-providers";
import { appConfig } from "../insaweb.config";
import { RiskAssessmentService } from "./insa-services";
import { RiskProfileNotifications } from "./insa-models";
import { SharedMethodsModule } from "./insa-custom-scripts";
import { routesWithoutTiles } from "./app-routing.module";

//declare var switch_style: any;
const kebabCase = require("lodash.kebabcase");

@Component({
	selector: "insaweb",
	templateUrl: "app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
	private riskProfileNotificationsSubscription;
	private riskProfileNotifications: RiskProfileNotifications = undefined;
	private menuShowRiskProfile: boolean = appConfig.menuShowRiskProfile;
	private menuShowMainWindow: boolean = appConfig.menuShowMainWindow;
	private menuShowClientContacts: boolean = appConfig.menuShowClientContacts;
	private menuShowGenericForms: boolean = appConfig.menuShowGenericForms;
	private menuShowDashboard: boolean = appConfig.menuShowDashboard;
	private menuShowSecurity: boolean = appConfig.menuShowSecurity;
	private menuShowCrossRates: boolean = appConfig.menuShowCrossRates;
	private menuShowOrdersWindow: boolean = appConfig.menuShowOrdersWindow;
	private menuShowNews: boolean =
		appConfig.menuShowNews !== undefined ? appConfig.menuShowNews : false;
	private user: string;
	private authenticated: boolean = false;
	private userInfoSubscription = undefined;
	private prevCompanyClassName = undefined;
	private loginSubscriber;
	public userHasInsaUserRole: boolean = false;
	public managementDashboardAccess: boolean = false;
	display: string;
	private embeddedMode: boolean = false;
	private InsaCronAvailable =
		appConfig.InsaCronAvailable !== undefined
			? appConfig.InsaCronAvailable
			: false;
	public appUserWelcome: boolean =
		appConfig.appUserWelcome === undefined ? true : appConfig.appUserWelcome;
	private portalLoginStatsAvaliable =
		appConfig.portalLoginStatsAvaliable !== undefined
			? appConfig.portalLoginStatsAvaliable
			: false;
	private loginStatsUserIdOK: boolean = false;
	private menuShowInsaTrader: boolean = appConfig.menuShowInsaTrader;
	private useLegacyIcons: boolean = appConfig.useLegacyIcons;
	private showMobileTraderShortcut: boolean =
		appConfig.showMobileTraderShortcut || false;

	constructor(
		private _router: Router,
		private _authService: AuthService,
		private _appStateProvider: appStateProvider,
		private zone: NgZone,
		private _insaService: InsaService,
		private _riskService: RiskAssessmentService,
		private _localize: LocalizeService,
		private _element: ElementRef,
		private titleService: Title,
	) {
		this.setTitle(appConfig.ClientTitle);
		this.setClientFavicon();
		window["appComponentRef"] = {
			zone: this.zone,
			component: this,
		};
		this.initAntiFraud();
		if (
			appConfig.allowTracking ||
			(appConfig.allowTracking === undefined &&
				process.env.INSA_TRACKING === JSON.stringify(true))
		) {
			if (window["gtag"]) {
				console.log("Google Analytics is ENABLED.");
			} else {
				console.log(
					"Google Analytics tracking is configured as enabled, but it's not found.",
				);
				console.log(
					"HINT: Try running dev or build with --env.INSA_TRACKING variable included.",
				);
			}
		}
		this.riskProfileNotificationsSubscription =
			this._riskService.RiskProfileNotificationsEvent.subscribe(
				(notifications: RiskProfileNotifications) => {
					this.riskProfileNotifications = notifications;
					if (notifications.noProfile) {
						// TODO: show warning or something to fill out questionnaire
					}
				},
			);
		this._router.events
			.pipe(filter((event) => event instanceof NavigationStart))
			.subscribe((event: NavigationStart) => {
				// //save transactions grid layout
				// this.saveGridLayout("TransactionsGrid");
				// //save portfolio grid layout
				// this.saveGridLayout("PortfolioGrid");
				// save generic grid layout
				this.saveGridLayout("genericGrid");
				// //save insa grid on pivot viewer layout
				// this.saveGridLayout("InsaGrid");
				// this.saveGridLayout("ChronosJobActivitiesList");
				this.saveInsaLayout();
			});
		/* tile visibility*/
		this._router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.tilesVisibility();

				const modalBackdrop = $(".modal-backdrop")[0];
				if (modalBackdrop && modalBackdrop.parentNode) {
					modalBackdrop.parentNode.removeChild(modalBackdrop);
				}

				// --> DN: commenting to decouple app.component from PorfolioGrid
				// the loading of GridLayout is done within the corresponding component
				//load transactions grid layout
				// this.loadGridLayout("TransactionsGrid");
				//load portfolio grid layout
				// this.loadGridLayout("PortfolioGrid");
				//load insa grid on pivot viewer layout
				// this.loadGridLayout("InsaGrid");
				//load chronos job activities grid layout
				// this.loadGridLayout("ChronosJobActivitiesList");
				// <-- code for persisting grid options moved to SharedMethods file and individual grid files. by Filip

				$("#filter").collapse("hide");
				window.scrollTo(0, 0);
				this.loadInsaLayout();
			});

		this._authService.UserInfoEmitter.subscribe((data) => {
			//this.managementDashboardAccess = data.OnLineServices > 1;
			let userHasManagementDashboardAccess = data.OnLineServices > 1;
			if (window.innerWidth > 768 && userHasManagementDashboardAccess) {
				this.managementDashboardAccess = true;
			} else {
				this.managementDashboardAccess = false;
			}
			this._localize.applyTranslations(this._element.nativeElement);
		});
	}

	//sidebar
	toggleCollapseSidebar() {
		$("#sidebar").toggleClass("active");
		this._appStateProvider.updateLayout();
	}

	saveGridLayout(GridName: string) {
		let grid: kendo.ui.Grid = $("#" + GridName).data("kendoGrid");
		if (grid) {
			let options: kendo.ui.GridOptions = grid.getOptions();
			options.dataSource = {
				group: options.dataSource.group,
				sort: options.dataSource.sort,
			};
			// localStorage["kendo " + GridName + " options"] = kendo.stringify(options);
			let metadataName;
			const urlSegments = this._router.url.split("/").filter((el) => el);
			if (GridName === "genericGrid") {
				options.columns = options.columns.filter((col) => col.field); // filter out action columns
				metadataName = urlSegments[1];
			}
			this._authService.saveDefaultGridLayout(GridName, metadataName, options);
			// SharedMethodsModule.loadGridGroupingAndSorting(GridName);
			//save application version information
			localStorage[GridName + "_VerisonInfo"] = appConfig.version;
		}
	}

	loadGridLayout(GridName: string) {
		let gridOptions = localStorage["kendo " + GridName + " options"];
		if (gridOptions) {
			let version: number = parseFloat(localStorage[GridName + "_VerisonInfo"]);
			if (version === appConfig.version) {
				let grid: kendo.ui.Grid = $("#" + GridName).data("kendoGrid");
				if (grid) {
					let customCommands: kendo.ui.GridColumnCommandItem[] =
						new Array<kendo.ui.GridColumnCommandItem>();
					//retrieve all custom commands defined on the grid
					grid.options.columns.forEach((col) => {
						if (col.command != undefined) {
							col.command.forEach((comm) => {
								if (comm.click !== undefined) {
									customCommands.push(comm);
								}
							});
						}
					});

					//let clickHandler: any = grid.options.columns[2].command[0].click;
					let loadedOptions: kendo.ui.GridOptions = JSON.parse(
						gridOptions,
						(key, value) => {
							if (key !== "dataSource") return value;
						},
					);
					loadedOptions.columns = loadedOptions.columns.filter((col) => {
						return grid.columns.find((c) => c.field === col.field);
					});
					loadedOptions.columns.forEach((col) => {
						// -->> set the title to the current text (and not the one which was saved!)
						// assumption is that it has already been translated
						let gcol = grid.columns.find((cg) => cg.field === col.field);
						if (gcol) {
							col.title = gcol.title;
						}
						// <<-- translation of title
						if (col.command != undefined) {
							col.command.forEach((command) => {
								let savedCustomCommand: kendo.ui.GridColumnCommandItem =
									customCommands.find((c) => c.name === command.name);
								if (
									savedCustomCommand != null ||
									savedCustomCommand != undefined
								) {
									command.click = savedCustomCommand.click; // all this trouble, just to re-apply the click function callback, because kendo couldn't serialize it to JSON....
								}
							});
						}
					});
					//loadedOptions.columns[2].command[0].click = clickHandler;
					grid.setOptions(loadedOptions);
					grid.refresh();
					SharedMethodsModule.loadGridGroupingAndSorting(GridName);
				}
			}
		}
	}

	private loadInsaLayout() {
		let currentColor = localStorage.color;
		if (currentColor) {
			let version: number = parseFloat(
				localStorage[localStorage.color + "_VerisonInfo"],
			);
			if (version === appConfig.version) {
				localStorage[localStorage.color] = currentColor;
			}
		}
	}

	private saveInsaLayout() {
		let currentColor = localStorage.color;
		if (currentColor) {
			localStorage[localStorage.color] = currentColor;
			localStorage[localStorage.color + "_VerisonInfo"] = appConfig.version;
			switch_style(currentColor);
		}
	}

	public setTitle(newTitle: string) {
		this.titleService.setTitle(newTitle);
	}

	private tilesVisibility() {
		const urlPath = this._router.url.split("?")[0];
		const hideTiles = routesWithoutTiles.some(
			(route: string) => urlPath === route || urlPath.startsWith(route + "/"),
		);
		this.display = hideTiles ? "none" : "block";
		this._appStateProvider.updateLayout();
	}

	private onResize(event) {
		this._appStateProvider.updateLayout();
	}

	private goToHomeClick(event) {
		var parsedData = JSON.parse(event.srcElement.textContent);
		this._router.navigate(["/home"], {
			queryParams: parsedData,
			queryParamsHandling: null,
		});
	}

	private goToTransactionsClick(event) {
		var parsedData = JSON.parse(event.srcElement.textContent);
		this._router.navigate(["/transactions"], {
			queryParams: parsedData,
			queryParamsHandling: null,
		});
	}

	private settingsClick(event) {
		$("#filter").collapse("show");
		$("#sidebar").collapse("hide");
	}

	private navigationClick(event) {
		$("#filter").collapse("hide");
		$("#sidebar").collapse("show");
	}

	logout(sender: any) {
		if (appConfig.ConfirmationWindowOnExit === true) {
			const dialogEl = $("<div></div>").appendTo("body");
			dialogEl.kendoDialog({
				width: "400px",
				title: this._localize.getLocalizedResource("Res1"),
				closable: false,
				modal: true,
				content:
					'<p style="text-align:center; font-size: 1rem; padding: 1rem 0;" localize="ResXXX">Jeste li sigurni da se želite odjaviti?</p>',
				actions: [
					{
						text: this._localize.getLocalizedResource("Res3") || "Cancel",
						cssClass: "btn btn-secondary",
						action: () => {
							dialogEl.data("kendoDialog").close();
						},
					} as any,
					{
						text: this._localize.getLocalizedResource("Res827") || "Log Out",
						cssClass: "btn btn-primary",
						primary: true,
						action: () => {
							dialogEl.data("kendoDialog").close();
							this.zone.run(() => {
								this._authService.logout();
							});
						},
					} as any,
				],
				open: () => {
					this._localize.applyTranslations(dialogEl[0]);
				},
				close: () => {
					setTimeout(() => {
						dialogEl.data("kendoDialog").destroy();
						dialogEl.remove();
					}, 300);
				},
			});
			dialogEl.data("kendoDialog").open();
		} else {
			this._authService.logout();
		}
	}

	routeIsActive(url: any) {
		return this._router.url === url;
	}

	ngOnInit() {
		// console.log('ngOnInit')
		// if there is custom logos defined do the changes...
		this.loginSubscriber =
			this._authService.LoggedInStatusChangedEmitter.subscribe((loggedin) => {
				// console.log('LoggedInStatusChangedEmitter: ' + JSON.stringify(loggedin))
				this.authenticated = loggedin.value;
				this.embeddedMode = loggedin.embeddedMode;
				this.updateAntiFraudAuthStatus(loggedin.value);
				// fix top empty space caused by #wrapper
				if (this._authService.isLoggedIn()) {
					this.userHasInsaUserRole = this._authService.roles
						? this._authService.roles.indexOf("InsaUser") >= 0
						: false;
					if (!loggedin.preventRedirect) {
						this._router.navigate(["/home"]);
					}
				} else {
					const url = this._router.url;
					if (
						!url.startsWith("/twoFactorSetup") &&
						!url.startsWith("/twoFactorValidate")
					) {
						this._router.navigate(["/login"]).then((navigated) => {
							if (!navigated) {
								window.location.reload();
							}
						});
					}
				}
			});
		this.userInfoSubscription = this._authService.UserInfoEmitter.subscribe(
			(userInfo) => {
				this.updateAntiFraudIdentity();
				const companyImageMappingPromise = appConfig.customLogo
					? appConfig.customLogo()
					: Promise.resolve(undefined); // require('../Images/companyImageMapping.json');
				companyImageMappingPromise.then((companyImageMapping) => {
					// console.log(companyImageMapping);
					if (companyImageMapping) {
						let company = "default";
						if (
							userInfo.AssignedCompanies &&
							userInfo.AssignedCompanies.length > 0
						) {
							company = userInfo.AssignedCompanies[0]; // we take the first one
						} else {
							company = userInfo.Company;
						}
						if (
							company === null ||
							company === undefined ||
							company.toString().trim() === ""
						) {
							company = "default"; // fallback to default
						}
						let img = companyImageMapping[company]; // find image in mapping
						if (!img) {
							console.log("Applying default logo!");
							img = companyImageMapping["default"];
						}
						if (img) {
							console.log(
								`Applying company logo for [${company}] using file ${img}`,
							);
							$(".navbar-inverse").attr(
								"style",
								`background-image:url(${img});`,
							);
						} else {
							console.log(
								`Company logo image not found (looked for id ${company}). Please check the definition in file /Images/companyImageMapping.json`,
							);
						}
					}
				});
				this.loginStatsUserIdOK = false;
				if (userInfo.Priority == 1000 || userInfo.Priority == 999)
					this.loginStatsUserIdOK = true; // userInfo.UserID == 153
			},
		);
	}

	ngOnDestroy() {
		this.loginSubscriber.unsubscribe();
		this.userInfoSubscription.unsubscribe();
	}

	private setClientFavicon(): void {
		const favicon = (appConfig as any).favicon;
		if (!favicon) return;
		document.head
			.querySelectorAll("link[rel*='icon']")
			.forEach((el) => el.remove());
		const link = document.createElement("link");
		link.rel = "icon";
		link.type = favicon.endsWith(".svg") ? "image/svg+xml" : "image/png";
		link.href = favicon;
		document.head.appendChild(link);
	}

	private initAntiFraud(): void {
		const antiFraud = (appConfig as any).antiFraud;
		if (!antiFraud?.enabled) return;

		const doInit = () => {
			const gib = window['gib'];
			if (!gib) return;
			const initOpts: any = {
				cid: antiFraud.cid,
				backUrl: antiFraud.backUrl,
			};
			if (antiFraud.gafUrl) initOpts.gafUrl = antiFraud.gafUrl;
			gib.init(initOpts);
			this.updateAntiFraudAuthStatus(this._authService.isLoggedIn());
			if (this._authService.isLoggedIn()) {
				this.updateAntiFraudIdentity();
			}
		};

		if (typeof window['gib'] !== 'undefined') {
			doInit();
		} else {
			window['onGIBLoad'] = doInit;
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = antiFraud.scriptPath;
			document.head.appendChild(script);
		}
	}

  private updateAntiFraudAuthStatus(isAuthenticated: boolean): void {
    const gib = window['gib'];
    if (!gib) return;
    gib.setAuthStatus(isAuthenticated ? gib.IS_AUTHORIZED : gib.IS_GUEST);
    if (!isAuthenticated) {
      // Group-IB requirement: očisti identity i session pri logoutu
      gib.setIdentity('');
      gib.setSessionID('');
    }
  }

  private updateAntiFraudIdentity(): void {
    const gib = window['gib'];
    if (!gib) return;
    if (this._authService.username) {
      gib.setIdentity(this._authService.username.toLowerCase());
    }
    if (this._authService.sessionId) {
      gib.setSessionID(this._authService.sessionId);
    }
  }
}



// WEBPACK FOOTER //
// ./app/app.component.ts